import React from "react";
import { Link } from "react-router-dom";
import StaticPage from "../../components/StaticPage";

const ARTICLES = [
    { slug: "managing-diabetes-type-2", title: "A practical guide to managing Type 2 diabetes", category: "Diabetes", read_min: 6 },
    { slug: "vitamin-d-deficiency-india", title: "Vitamin D deficiency in India — what every adult should know", category: "Vitamins", read_min: 4 },
    { slug: "hypertension-lifestyle", title: "Hypertension: 7 lifestyle tweaks that actually move the needle", category: "Cardio", read_min: 5 },
    { slug: "antibiotic-resistance", title: "Antibiotic resistance — finishing the course matters", category: "Rx safety", read_min: 4 },
    { slug: "baby-immunisation-schedule", title: "Baby immunisation schedule (India) — month by month", category: "Pediatrics", read_min: 8 },
    { slug: "ayurveda-meets-evidence", title: "When Ayurveda meets evidence-based medicine", category: "Ayurveda", read_min: 7 },
];

const Articles = () => (
    <StaticPage
        title="Health Articles"
        crumb="Articles"
        testId="page-articles"
        intro="Doctor-reviewed long-form articles on the conditions that matter most to Indian households."
    >
        <div className="grid gap-4 md:grid-cols-2">
            {ARTICLES.map((a) => (
                <Link key={a.slug} to={`/articles/${a.slug}`} className="group rounded-2xl border border-zinc-100 bg-white p-5 transition-all hover:border-brand-200 hover:shadow-soft dark:border-white/10 dark:bg-white/5">
                    <p className="label-uppercase">{a.category} · {a.read_min} min read</p>
                    <h3 className="mt-1 text-base font-semibold text-zinc-900 group-hover:text-brand-700 dark:text-zinc-100">{a.title}</h3>
                    <p className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">Read article →</p>
                </Link>
            ))}
        </div>
    </StaticPage>
);

export default Articles;
